import React, { useContext, useEffect, useState } from "react";
import NavBar from "../components/NavBar";
import PlatformsBox from "../components/PlatformsBox";
import PlatformBox2 from "../components/PlatformBox2";
import PriceCompnent from "../components/PriceCompnent";
import Footer from "../components/Footer";
import Whatsapp from "../assets/whatsapp-icon.png";
import Telegram from "../assets/telegram-icon.png";
import Binanace from "../assets/binance-icon.png";
import Bybit from "../assets/bybit.png";
import Metatrader from "../assets/metatrader.svg";
import { useNavigate } from "react-router-dom";
import IntrestedUsers from "./intrestedUsers";
import { HidepopupContext } from "../context/Hidepopup";

export default function LandingPage() {
  let navigate = useNavigate();
  let { hidePopUp,setHidePopUp } = useContext(HidepopupContext);
  let [mode] = useState("Dark");
  let getStarted = () => {
    navigate("/auth/signup");
  };
  useEffect(()=>{
    let showform = setTimeout(()=>{
       setHidePopUp(false);
     },20920)
     return ()=>clearTimeout(showform)
   },[setHidePopUp])
  return (
    <div
      className={
        mode === "Dark"
          ? "w-full overflow-hidden bg-black  text-white  "
          : "w-full overflow-hidden bg-white  text-black "
      }
    >
      {hidePopUp ? '' : <IntrestedUsers />}
      <NavBar />
      <section className="pb-24 flex flex-col justify-center items-center ">
        <h1 className="text-center lg:font-[900] lg:text-[5rem] text-[3.3rem] lg:w-[80%]">
          Automate Your Trading Success
        </h1>
        <p className="text-center w-[60%] text-gray-300">
          Join our platform and let our expert trading signals handle the rest.
          Register now and watch your trades automatically open, close, and
          manage themselves.
        </p>
        <span className="flex justify-center items-center p-20">
          <button
            className="m-auto bg-[#A7FF35] hover:bg-[#bdee7c] text-black p-3 w-fit rounded-full font-bold " disabled
            onClick={getStarted}
          >
            Get Started 🔥
          </button>
        </span>
        <div className="flex gap-4 justify-center w-full lg:flex-row flex-col items-center">
          <PlatformsBox text="metatrade4&5" styles={"lg:translate-x-[10em]"} />
          <PlatformsBox
            text={"bybit"}
            image={Bybit}
            styles="lg:-translate-y-[3.5em]"
          />
          <PlatformsBox
            text="binance"
            image={Binanace}
            styles={"lg:-translate-x-7"}
            rotate="lg:rotate-[30deg]"
          />
          <PlatformsBox
            text="whatsapp"
            image={Whatsapp}
            styles={"lg:-translate-x-[5em] lg:z-10"}
            rotate="lg:-rotate-[50deg]"
          />
          <PlatformsBox
            text="telegram"
            image={Telegram}
            styles={"lg:-translate-x-[12em]"}
            rotate="lg:rotate-[0deg]"
          />
        </div>
      </section>
      <section className="bg-[#A8FF35] max-h-screen w-screen flex py-20   flex-col">
        <h1 className=" lg:text-[4.5rem] text-center text-[2.5rem] mb-24 text-black font-bold">
          Copy Trading Simplified
        </h1>
        <div>
          <div className="bg-white p-16 w-fit self-center m-auto">
            <PlatformsBox rotate="rotate-0" />
          </div>
        </div>
        <p className="text-center mt-10 text-black text-[1rem]">
          Experience the ease of automated trading. Sign up and let our
          sophisticated algorithms work for you
        </p>
      </section>
      <section className="bg-[#FAFAFA] text-black  lg:py-28 py-24">
        <h1 className="lg:text-[4rem] text-[2.25rem] text-center font-bold capitalize">
          All Exchanges to connect Bridge
        </h1>
        <div className="flex flex-wrap m-auto justify-center items-center gap-6 mt-5">
          <PlatformBox2 imgSrc={Binanace} />
          <PlatformBox2 imgSrc={Metatrader} />
          <PlatformBox2 imgSrc={Bybit} />
        </div>

        <h1 className="lg:text-[4rem] text-[2.25rem] text-center font-bold capitalize mt-10">
          All Socials to connect Bridge
        </h1>
        <div className="flex flex-wrap m-auto justify-center items-center gap-6 mt-5">
          <PlatformBox2 imgSrc={Whatsapp} />
          <PlatformBox2 imgSrc={Telegram} />
        </div>
      </section>
      <section className="lg:py-28 py-24" id="pricing">
        <h1 className="lg:text-[4rem] text-[2.25rem] text-center font-bold capitalize mb-20">
          Get your best deal
        </h1>
        <div className="flex lg:pr-80 w-full items-center flex-wrap gap-7 lg:translate-x-32 justify-center">
          <PriceCompnent styles={"bg-white h-[29.1em]"}>
            <ul className="flex flex-col gap-3 mb-10 text-black">
              <li>One account</li>
              <li>Limited access to demo features</li>
            </ul>
          </PriceCompnent>
          <PriceCompnent
            styles={"bg-[#A8FF35] h-[29.1em]"}
            price="$37.18"
            btnName="Subscribe"
            plan="Personal"
          >
            <ol className="flex flex-col gap-3 mb-10 text-black">
              <li>Full access to automated trading signals</li>
              <li>One account</li>
            </ol>
          </PriceCompnent>
          <PriceCompnent
            styles={"bg-white h-[29.1em]"}
            price="$223.07"
            btnName="Subscribe"
            plan="duo"
          >
            <ul className="flex flex-col gap-3 mb-10 text-black">
              <li>Full access to automated trading signals</li>
              <li>Two accounts</li>
            </ul>
          </PriceCompnent>
          <PriceCompnent
            styles={"bg-[#A8FF35]"}
            price="$48"
            btnName="Subscribe"
            plan="Premium"
          >
            <ul className="flex flex-col gap-3 mb-10 text-black">
              <li>Includes trading signals</li>
              <li>Full access to automated trading features</li>
              <li>One account</li>
            </ul>
          </PriceCompnent>
        </div>
      </section>
      <section className="bg-[#A8FF35] lg:p-52 py-20 flex flex-col">
        <h3 className="text-center text-[#000000]  lg:text-[72px] text-[36px] font-extrabold">
          Join us on email for
        </h3>
        <h3 className="text-center text-[#87D322]  lg:text-[72px] text-[36px] font-extrabold">
          more trending topics
        </h3>
        <button
          className="bg-black hover:bg-[#000000bb] p-6 w-52 rounded-full self-center mt-7 "
          onClick={()=>setHidePopUp(false)}
        >
          Join Now
        </button>
      </section>
      <Footer />
    </div>
  );
}
